/**
 * Technical Document Preview
 *
 * Handles the preview modal for technical documents.
 * Shows images directly, PDFs/files in an iframe.
 */
class TechnicalDocumentPreview extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('[data-preview-modal]');
    this.iframe = this.querySelector('[data-preview-iframe]');
    this.image = this.querySelector('[data-preview-image]');
    this.titleEl = this.querySelector('[data-preview-title]');
    this.closeBtn = this.querySelector('[data-preview-close]');

    if (!this.modal) return;

    this.querySelectorAll('[data-document-preview]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const url = btn.dataset.documentUrl;
        const name = btn.dataset.documentName;
        const type = btn.dataset.documentType;
        this.open(url, name, type);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });

    this.handleKeydown = (e) => {
      if (e.key === 'Escape') this.close();
    };
  }

  open(url, name, type) {
    if (!this.modal) return;
    this.titleEl.textContent = name || 'Document Preview';

    if (type === 'image') {
      if (this.iframe) {
        this.iframe.src = '';
        this.iframe.style.display = 'none';
      }
      if (this.image) {
        this.image.src = url;
        this.image.alt = name || '';
        this.image.style.display = 'block';
      }
    } else {
      if (this.image) {
        this.image.src = '';
        this.image.style.display = 'none';
      }
      if (this.iframe) {
        this.iframe.src = url;
        this.iframe.style.display = 'block';
      }
    }

    this.modal.classList.remove('hidden');
    this.modal.classList.add('flex');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.handleKeydown);
  }

  close() {
    if (!this.modal) return;
    this.modal.classList.add('hidden');
    this.modal.classList.remove('flex');
    if (this.iframe) {
      this.iframe.src = '';
      this.iframe.classList.add('hidden');
    }
    if (this.image) {
      this.image.src = '';
      this.image.classList.add('hidden');
    }
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.handleKeydown);
  }
}

if (!customElements.get('technical-document-preview')) {
  customElements.define('technical-document-preview', TechnicalDocumentPreview);
}
